<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto flex justify-center">
      <img class="rounded-xl" :src="image" :alt="alttext" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface IProps {
  id: string;
  background?: string;
  image?: string;
  alttext?: string;
  removeWhitespace?: boolean;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [props.background ? props.background : "", props.removeWhitespace ? "!p-0" : "pb-16 lg:py-24", "pt-6"];
});
</script>
